import * as action_types from "./constants";

const initialState = {
  noticeList: {
    count: 0,
    results: [],
  },
  prospectList: {
    count: 0,
    results: [],
  },
};

export default (state = initialState, action) => {
  const { type, data } = action;
  switch (type) {
    case action_types.GET_NOTICES:
      return { ...state, noticeList: data };
    case action_types.GET_PROSPECTS:
      return { ...state, prospectList: data };
    default:
      return state;
  }
};
